import {CustomCode} from "./common.model";

export class MealDurationType extends CustomCode{
  public static _registered = new Map<string, MealDurationType>();
  static DEFAULT_DURATION = new MealDurationType('DEFAULT_DURATION');
  static PUNCH_DURATION  = new MealDurationType('PUNCH_DURATION');
  // static PUNCH_DURATION_WITH_MIN  = new MealDurationType('PUNCH_DURATION_WITH_MIN');

  static ALL = Array.from(MealDurationType._registered.values());


  constructor (code: string) {
    super(code);
    MealDurationType._registered.set(code, this);
  }


  static retrieveFromCode(code: string): MealDurationType {
    const res = MealDurationType._registered.get(code);
    if (!res) {
      console.log('MealDurationType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

  toTranslateKey():string{
    return 'MEAL_DURATION_TYPE_' + this.code;
  }

}
